import { createContext } from 'react'
import { FarmsContext } from './types'

const context = createContext<FarmsContext>({
  newFarms: [],
  endedFarms: [],
  otherFarms: [],
  allNftFarms: [],
  bakeFarms: [],
  bakeV2Farms: [],
  petFarms: [],
  unharvested: 0,
  bPetFarms: [],
  weaponFarms: [],
  bestFarms: [],
  weaponnftFarms: [],
  petnftFarms: [],
  helmetFarms: [],
  ethFarms: [],
  aethFarms: [],
  springFarms: [],
  aethAndethFarms: [],
  wsoteFarms: [],
  shieldFarms: [],
  bryFarms: [],
  bakeStakingFarms: [],
  defi100Farms: [],
  defi100OLDFarms: [],
  bananaFarms: [],
  seascapeNftFarms: [],
  pcwsFarms: [],
  warFarms: [],
  war2Farms: [],
  tkoNftFarms: [],
  hatNftFarms: [],
  dieselFarms: [],
  mxFarms: [],
  aliceFarms: [],
  aliceNftFarms: [],
  bondlyNftFarms: [],
  dfyFarms: [],
  gfxFarms: [],
  xDittoFarms: [],
  sactFarms: [],
  pet3Farms: [],
  hyfiFarms: [],
  ginuFarms: [],
  levFarms: [],
  bondlyFarms: [],
  bondly2Farms: [],
  tctFarms: [],
  tkoFarms: [],
  tkonftStakeFarms: [],
  bmoncnftStakeFarms: [],
  bmmnftStakeFarms: [],
  nftStakeFarms: [],
  oneInchBakeNftFarms: [],
  tko2Farms: [],
  bnrgFarms: [],
  tsaFarms: [],
  tlmFarms: [],
  xdittoNftFarms: [],
  doggyTlmFarms: [],
  barkTlmFarms: [],
  tokauTlmFarms: [],
  toynftStakeFarms: [],
  gatTlmFarms: [],
  wsgFarms: [],
  dogoFarms: [],
  toyNftFarms: [],
  bethFarms: [],
  tokauFarms: [],
  eggFarms: [],
  kalataFarms: [],
  donFarms: [],
  ntFarms: [],
  moniFarms: [],
  kxaFarms: [],
  nblFarms: []
})

export default context
